export default "__VITE_ASSET__BqnQ5p9F__"